import React from 'react';
import { productAnalysisStore } from 'stores/ProductWikiStores/ProductAnalysisStore';
import { observer } from 'mobx-react-lite';
import RegulatoryTabSkeleton from './components/RegulatoryTabSkeleton/RegulatoryTabSkeleton';
import APIFDFSection from './components/APIFDFSection/APIFDFSection';
import './RegulatoryTab.styles.scss';
import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import { RegulatoryTabProps } from './RegulatoryTab.type';
import useRegulatoryTab from './useRegulatoryTab.logic';

const RegulatoryTab: React.FC<RegulatoryTabProps> = observer(function RegulatoryTab({
  regulatoryData: propRegulatoryData,
  complianceData: _complianceData,
}) {
  const {
    regulatoryFilters: _regulatoryFilters,
    setRegulatoryFilters: _setRegulatoryFilters,
    getRiskLevelColor: _getRiskLevelColor,
    getComplianceScoreClass: _getComplianceScoreClass,
    isLoading,
    taaSummary: _taaSummary,
    localCountryMatrix: _localCountryMatrix,
    regulatoryData,
    // AI Insights
    aiInsights: _aiInsights,
    isInsightsLoading: _isInsightsLoading,
    insightsError: _insightsError,
  } = useRegulatoryTab({ productAnalysisStore, regulatoryData: propRegulatoryData });

  // Don't render if no regulatory data is available
  if (!regulatoryData && !isLoading) {
    return (
      <section className="content-section">
        <div className="section-header">
          <h3 className="section-title">Import & Export</h3>
        </div>
        <div className="section-content" style={{ textAlign: 'center', padding: '3rem' }}>
          <p style={{ color: '#e74c3c' }}>
            {productAnalysisStore.regulatoryError || 'No regulatory data available.'}
          </p>
        </div>
      </section>
    );
  }

  return (
    <section className="content-section">
      <div className="section-header">
        <h3 className="section-title">Import & Export</h3>
        {/* <span className="section-subtitle">
          Based on DailyMed SPL data, FDA inspection records, Orange Book | Updated: Dec 15, 2024
        </span> */}
      </div>
      <div className="section-content">
        {isLoading ? (
          <RegulatoryTabSkeleton />
        ) : regulatoryData ? (
          <>
            {/* <div className="country-matrix">
              <h4 className="country-matrix-title">Manufacturers Matrix</h4>
              <div className="regulatory-datatable-wrapper">
                <DataTable
                  value={localCountryMatrix}
                  filters={regulatoryFilters}
                  onFilter={e => setRegulatoryFilters(e.filters)}
                  filterDisplay="row"
                  globalFilterFields={[
                    'manufacturer',
                    'apiSource',
                    'fdfManufacturing',
                    'taaStatus',
                    'volumeShare',
                    'fss',
                    'dapa',
                    'riskLevel',
                  ]}
                  emptyMessage="No regulatory data available"
                  className="regulatory-datatable"
                  scrollable
                  scrollHeight="400px"
                >
                  <Column
                    field="manufacturer"
                    header="Manufacturer"
                    filter
                    filterPlaceholder="Search Manufacturer"
                    showFilterMenu={false}
                    showClearButton={true}
                    filterMatchMode={FilterMatchMode.CONTAINS}
                  />
                  <Column
                    field="apiSource"
                    header="API Source"
                    filter
                    filterPlaceholder="Search API Source"
                    showFilterMenu={false}
                    showClearButton={true}
                    filterMatchMode={FilterMatchMode.CONTAINS}
                  />
                  <Column
                    field="fdfManufacturing"
                    header="FDF Manufacturing"
                    filter
                    filterPlaceholder="Search FDF Manufacturing"
                    showFilterMenu={false}
                    showClearButton={true}
                    filterMatchMode={FilterMatchMode.CONTAINS}
                  />
                  <Column
                    field="volumeShare"
                    header="Volume Share"
                    filter
                    filterPlaceholder="Search Volume Share"
                    showFilterMenu={false}
                    showClearButton={true}
                    filterMatchMode={FilterMatchMode.CONTAINS}
                  />
                  <Column
                    field="fss"
                    header="FSS"
                    filter
                    filterPlaceholder="Search FSS"
                    showFilterMenu={false}
                    showClearButton={true}
                    filterMatchMode={FilterMatchMode.CONTAINS}
                  />
                  <Column
                    field="dapa"
                    header="DAPA"
                    filter
                    filterPlaceholder="Search DAPA"
                    showFilterMenu={false}
                    showClearButton={true}
                    filterMatchMode={FilterMatchMode.CONTAINS}
                  />
                  <Column
                    field="riskLevel"
                    header="Risk Level"
                    filter
                    filterPlaceholder="Search Risk Level"
                    showFilterMenu={false}
                    showClearButton={true}
                    filterMatchMode={FilterMatchMode.CONTAINS}
                    body={rowData => (
                      <span style={{ color: getRiskLevelColor(rowData.riskLevel) }}>
                        {rowData.riskLevel.charAt(0).toUpperCase() + rowData.riskLevel.slice(1)}
                      </span>
                    )}
                  />
                </DataTable>
              </div>

              <div className="taa-summary-container">
                <div className="taa-summary">
                  <strong>TAA Summary:</strong> {taaSummary.summaryText}
                </div>
              </div>
            </div> */}

            {/* APIFDF Import & Export Data Section */}
            <APIFDFSection />

            <div className="regulatory-sections-content">
              {/* <div className="label-attributes">
                {regulatoryData.attributes.map((attribute, index) => (
                  <div key={index} className="attribute-group">
                    <h4 className="attribute-group-title">{attribute.title}</h4>
                    {attribute.items.map((item, itemIndex) => (
                      <p key={itemIndex}>
                        <span className="attribute-group-text-item">{item.label}:</span>{' '}
                        <span className="attribute-group-text-item-value">{item.value}</span>
                      </p>
                    ))}
                  </div>
                ))}
              </div> */}

              {/* <div className="compliance-score">
                <div className="score-gauge">
                  <div
                    className={`score-gauge ${getComplianceScoreClass(regulatoryData.complianceScore.score)}`}
                  >
                    {regulatoryData.complianceScore.score}
                  </div>
                </div>
                <div>
                  <h4 className="compliance-score-title">Regulatory Compliance Risk Score</h4>
                  <p>
                    <strong className="compliance-score-title-text">
                      {regulatoryData.complianceScore.level.charAt(0).toUpperCase() +
                        regulatoryData.complianceScore.level.slice(1)}{' '}
                      Risk ({regulatoryData.complianceScore.score}/100):
                    </strong>{' '}
                    {regulatoryData.complianceScore.description}
                  </p>
                  <div className="risk-factors">
                    <strong>Risk Factors:</strong>
                    <br />
                    {regulatoryData.complianceScore.factors.map((factor, index) => (
                      <div key={index} className="risk-factor-item">
                        • {factor.name} ({factor.weight}): {factor.score}
                        {factor.details && <span> - {factor.details}</span>}
                      </div>
                    ))}
                  </div>
                </div>
              </div> */}

              {/* <div className="inspection-history">
                <div className="narrative-box">
                  <h4 className="narrative-box-text-title">FDA Inspection History (36M)</h4>
                  <ul>
                    <li>
                      <span className="narrative-box-text-item">Teva Sellersville:</span>{' '}
                      <span className="narrative-box-text-item-value">
                        VAI (2023-02) - No issues
                      </span>
                    </li>
                    <li>
                      <span className="narrative-box-text-item">Mylan Morgantown:</span>{' '}
                      <span className="narrative-box-text-item-value">
                        VAI (2022-11) - No issues
                      </span>
                    </li>
                    <li>
                      <span className="narrative-box-text-item">Sandoz Princeton:</span>{' '}
                      <span className="narrative-box-text-item-value">
                        VAI (2023-06) - No issues
                      </span>
                    </li>
                    <li>
                      <span className="narrative-box-text-item">Amneal Ahmedabad:</span>{' '}
                      <span className="narrative-box-text-item-value">
                        VAI (2023-08) - Post-recall inspection
                      </span>
                    </li>
                    <li>
                      <span className="narrative-box-text-item">Aurobindo Hyderabad:</span>{' '}
                      <span className="narrative-box-text-item-value">
                        OAI→VAI (2022-04→2023-01)
                      </span>
                    </li>
                    <li>
                      <span className="narrative-box-text-item">Cipla Mumbai:</span>{' '}
                      <span className="narrative-box-text-item-value">
                        Not inspected (recent entrant)
                      </span>
                    </li>
                  </ul>
                  <p className="narrative-box-text-item-value">
                    <strong>Trend:</strong> All active sites maintaining VAI status; inspection
                    frequency: every 2-3 years
                  </p>
                </div>

                <div className="narrative-box">
                  <h4 className="narrative-box-text-title">Supply Chain Vulnerabilities</h4>
                  <ul>
                    <li>
                      <span className="narrative-box-text-item">API Concentration:</span>{' '}
                      <span className="narrative-box-text-item-value">
                        27% volume from India (geographic risk)
                      </span>
                    </li>
                    <li>
                      <span className="narrative-box-text-item">Single Source Risk:</span>{' '}
                      <span className="narrative-box-text-item-value">
                        Each manufacturer has single API/FDF site
                      </span>
                    </li>
                    <li>
                      <span className="narrative-box-text-item">TAA Dependency:</span>{' '}
                      <span className="narrative-box-text-item-value">
                        Government market requires 73% TAA compliance
                      </span>
                    </li>
                    <li>
                      <span className="narrative-box-text-item">Raw Material:</span>{' '}
                      <span className="narrative-box-text-item-value">
                        API sourcing from 3 major suppliers globally
                      </span>
                    </li>
                    <li>
                      <span className="narrative-box-text-item">Transportation:</span>{' '}
                      <span className="narrative-box-text-item-value">
                        Standard pharma logistics, no cold chain
                      </span>
                    </li>
                  </ul>
                  <p className="narrative-box-text-item-value">
                    <strong>Mitigation:</strong> Multiple suppliers, buffer inventory, established
                    backup sources
                  </p>
                </div>
              </div> */}

              {/* AI-Powered Regulatory Strategy Recommendations */}
              {/* {isInsightsLoading ? (
                <InsightsSkeleton />
              ) : insightsError ? (
                <div className="narrative-box ai-insights-box error">
                  <h4 className="narrative-box-text-title">Regulatory Strategy Recommendations</h4>
                  <div className="narrative-content">
                    <div className="insights-error-container">
                      <i className="fas fa-exclamation-triangle insights-error-icon" />
                      <div className="insights-error-details">
                        <p className="insights-error-message">{insightsError}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ) : aiInsights && aiInsights.length > 0 ? (
                <div className="narrative-box ai-insights-box">
                  <h4 className="narrative-box-text-title">Regulatory Strategy Recommendations</h4>
                  <div className="narrative-content">
                    <ul className="ai-insights-list">
                      {aiInsights.map((insight, index) => (
                        <li key={index} className="insight-item">
                          <span className="narrative-box-text-item">{insight.bullet}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ) : (
                <div className="narrative-box ai-insights-box no-data">
                  <h4 className="narrative-box-text-title">Regulatory Strategy Recommendations</h4>
                  <div className="narrative-content">
                    <div className="insights-no-data">
                      <span className="no-data-icon">📋</span>
                      <p className="no-data-message">No AI insights available at the moment.</p>
                      <p className="no-data-hint">
                        Insights will be generated based on regulatory compliance data analysis.
                      </p>
                    </div>
                  </div>
                </div>
              )} */}
            </div>
          </>
        ) : null}
      </div>
    </section>
  );
});

export default RegulatoryTab;
